import React from "react";
import PropTypes from "prop-types";
import PostToBePublishedStatus from "../../../publishing/PostToBePublishedStatus";

export default class SocialPublishingStatus extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    post: PropTypes.any.isRequired // NewPostMessage
  };
  render() {
    /** @typedef {NewPostMessage} */
    const { post, className } = this.props;

    if (!post.postToBePublished) {
      return null;
    } else {
      /** @typedef {PostToBePublished} */
      const publishing = post.postToBePublished;
      let badge;
      if (!post.isUnpublished) {
        badge = { className: "badge-primary", content: "Published" }
      } else if (
        PostToBePublishedStatus.Error === publishing.publishingStatus ||
        (!!publishing.inReplyTo && publishing.countFailed > 0)
      ) {
        badge = { className: "badge-danger", content: "Failed to Publish" }
      } else if (
        [
          PostToBePublishedStatus.Pending,
          PostToBePublishedStatus.Published
        ].includes(publishing.publishingStatus)
      ) {
        badge = { className: "badge-primary", content: "Publishing" }
      } else if (publishing.rejectedForPublishing) {
        badge = { className: "badge-danger", content: "Unapproved" }
      } else if (publishing.requiresApproval) {
        badge = { className: "badge-warning", content: "Pending Approval" }
      }

      if (!badge) {
        return null
      } else {
      return <span className={`${className || ""}`}><span className={`badge ${badge.className}`}>{badge.content}</span></span>
      }
    }
  }
}
